import React, { useEffect, useState } from "react";
import { Table, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getStates, getClusters, resetState } from "../features/statecity/statecitySlice";
import { Link } from "react-router-dom";

const stateCityColumns = [
  {
    dataIndex: "key",
    title: "Sr No",
    width: 10,
  },
  {
    dataIndex: "name",
    title: "Name",
    width: 50,
  },
  {
    dataIndex: "code",
    title: "Code",
    width: 30,
  },
  {
    dataIndex: "districts",
    title: "Districts",
    width: 80,
  },
];

const clusterColumns = [
  {
    dataIndex: "key",
    title: "Sr No",
    width: 70,
  },
  {
    dataIndex: "clusterName",
    title: "Cluster Name",
    width: 150,
  },
  {
    dataIndex: "name",
    title: "Name",
    width: 150,
  },
  {
    dataIndex: "code",
    title: "Code",
    width: 100,
  },
  {
    dataIndex: "districts",
    title: "Districts",
    width: 200,
  },
];

const StateCluster = () => {
  const dispatch = useDispatch();
  const [selectedTab, setSelectedTab] = useState("1");

  useEffect(() => {
    dispatch(resetState());
    dispatch(getStates());
    dispatch(getClusters());
  }, [dispatch]);

  const stateCityData = useSelector((state) => state.statecity.statelist);
  const clusterData = useSelector((state) => state.statecity.clusterlist);

  const handleChangeTab = (key) => {
    setSelectedTab(key);
  };

  const getCurriculamData = () => {
    switch (selectedTab) {
      case "1":
        return stateCityData;
      case "2":
        return clusterData;
      default:
        return [];
    }
  };

  const curriculamState = getCurriculamData();

  if (!Array.isArray(curriculamState)) {
    return <div>Data is not in expected format</div>;
  }

  const data1 = curriculamState.map((item, index) => {
    return {
      key: index + 1,
      name: item.state_name || item.name || "",
      code: item.code || "",
      districts: Array.isArray(item.district_name) ? item.district_name.join(", ") : "",
      clusterName: item.clusterName || item.name || "",
    };
  });

  return (
    <div>
      <h3 className="mb-4 title">State City | Cluster Data</h3>
      <div style={{ marginBottom: 16, backgroundColor: "rgb(31 156 142)", padding: "10px" }}>
        <Link to="/admin/add-state" className="fs-3 text-danger">
          <button className="btn btn-info rounded-3 my-2">Add State City | Cluster</button>
        </Link>
      </div>

      <Tabs defaultActiveKey={selectedTab} centered onChange={handleChangeTab}>
        <Tabs.TabPane tab="State City" key="1">
          <Table
            style={{ marginBottom: 16, padding: "20px" }}
            className="custom-table"
            columns={stateCityColumns}
            dataSource={data1}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Cluster" key="2">
          <Table
            style={{ marginBottom: 16, padding: "20px" }}
            className="custom-table"
            columns={clusterColumns}
            dataSource={data1}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default StateCluster;
